<template>
  <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onCreate">
    <v-card tile>
      <v-card-title class="grey lighten-2">
        Lägg till förseningar från Här och Nu
      </v-card-title>

      <v-card-text class="mt-2 pa-0">
        <MasterdataTableContainer
          show-select
          v-model="selected"
          :default-table-height="799"
          :loading="fetching"
          :headers="headers"
          :table-data="tableData"
          item-key="_uuid"
        >
          <v-menu
            slot="left"
            v-model="dateDialoag"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                rounded
                filled
                v-model="dateRangeText"
                dense
                :hide-details="true"
                v-on="on"
                v-bind="attrs"
                readonly
                prepend-inner-icon="mdi-calendar-range"
                class="mr-4"
              ></v-text-field>
            </template>
            <v-date-picker
              first-day-of-week="1"
              v-model="dates"
              range
            ></v-date-picker>
          </v-menu>
        </MasterdataTableContainer>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer />
        <v-btn rounded @click="closeModal">Avbryt</v-btn>
        <v-btn
          rounded
          type="submit"
          color="primary"
          :disabled="!selected.length"
          :loading="createPending"
        >
          Lägg till markerade
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import MasterdataTableContainer from '@/modules/masterdata/components/MasterdataTableContainer'
import { sync, get } from 'vuex-pathify'
import { required } from '@/common/validationRules'
import orderBy from 'lodash.orderby'
import { format, addDays } from 'date-fns'
import { v4 as uuidv4 } from 'uuid'
import gql from 'graphql-tag'

export default {
  name: 'DelayImportFromUtin',

  components: {
    MasterdataTableContainer
  },

  data: () => ({
    required,
    dateDialoag: false,
    valid: true,
    createPending: false,
    fetching: false,
    selected: [],
    unhandledDelays: [],
    dates: [
      format(addDays(new Date(), -1), 'yyyy-MM-dd'),
      format(new Date(), 'yyyy-MM-dd')
    ],
    headers: [
      {
        text: 'Tågnr.',
        value: 'train_number'
      },
      {
        text: 'Plats',
        value: '_location_place'
      },
      {
        text: 'Platstid',
        value: '_location_time'
      },
      {
        text: 'Försening',
        value: 'delay'
      }
    ]
  }),

  computed: {
    stops: get('event/stops'),
    model: sync('trainDeviation/model'),
    selectedEventUUID: get('event/selectedUUID'),

    datesSorted() {
      return orderBy(this.dates, [x => x], ['asc'])
    },

    dateRangeText() {
      return this.dates.join(' ~ ')
    },

    tableData() {
      const findLocationName = signature => {
        const location = this.stops.find(
          x => x.short_name === signature.toUpperCase()
        )
        return location ? location.stop_name : signature.toUpperCase()
      }

      return orderBy(
        (this.unhandledDelays || []).map(x => ({
          ...x,
          _uuid: uuidv4(),
          _event: x.delay?.event?.title || '',
          delay: x.delay_minutes,
          _advertised_location_time: format(
            new Date(x.advertised_location_time),
            'yyyy-MM-dd HH:mm'
          ),
          _location_place: findLocationName(x.location_place),
          _location_time: format(new Date(x.location_time), 'yyyy-MM-dd HH:mm')
        })),
        ['advertised_location_time'],
        ['desc']
      ).filter(x => !x._event.length)
    }
  },

  watch: {
    dates: {
      handler: 'getUnhandledDelays',
      immediate: true
    }
  },

  methods: {
    async getUnhandledDelays() {
      if (this.datesSorted.length !== 2) return
      this.fetching = true
      const [from, to] = this.datesSorted
      this.unhandledDelays = await this.$store.dispatch(
        'linkDeviation/fetchStatelessUnhandledDelays',
        {
          from,
          to,
          district_id: this.$store.get('app/selectedDistrictId')
        }
      )
      this.fetching = false
    },

    async onCreate() {
      this.createPending = true

      for (let item of this.selected) {
        const model = {
          uuid: uuidv4(),
          event_uuid: this.selectedEventUUID,
          ...Object.keys(item)
            .filter(key =>
              [
                'delay',
                'train_number',
                'type',
                'location_place',
                'location_time',
                'event_uuid'
              ].includes(key)
            )
            .reduce((acc, next) => {
              acc[next] = item[next]
              return acc
            }, {})
        }

        await this.createDelay({
          ...model,
          type: 'RST',
          checked: true
        })
      }

      this.createPending = false

      this.closeModal()
    },

    async createDelay(payload) {
      const { data } = await this.$apollo.mutate({
        mutation: gql`
          mutation($payload: CreateDelayInput!) {
            createDelay(payload: $payload) {
              delay_uuid
              delay {
                uuid
                event_uuid
                train_number
                type
                location_place
                location_time
                delay
                checked
                deleted
              }
            }
          }
        `,
        variables: {
          payload
        }
      })

      this.$store.set(
        `delay/data@${data.createDelay.delay_uuid}`,
        data.createDelay.delay
      )
    },

    closeModal() {
      this.$store.commit('delay/resetModel')
      this.$emit('close')
    }
  }
}
</script>
